import { FilterType } from 'frontend/enums'
import { Filters } from 'frontend/types'
import EducationLevel from './components/EducationLevel'
import Language from './components/Language'
import SignLanguageAndAudioDescription from './components/SignLanguageAndAudioDescription'
import TeacherResources from './components/TeacherResources'
import { SearchParams } from 'backend/services/types/urApiService.types'
import Sort from './components/Sort'
import SchoolSubjectExtended from './components/SchoolSubjectExtended'
import KnowledgeAreaExtended from './components/KnowledgeAreaExtended'

interface Props {
  hiddenFilters: FilterType[]
  filters: Filters
  searchParams: SearchParams
  executeSearch: (
    params: SearchParams,
    shouldResetAllFilters?: boolean,
  ) => Promise<void>
  includeRelevance?: boolean
}

const FilterItems = ({
  hiddenFilters,
  filters,
  searchParams,
  executeSearch,
  includeRelevance,
}: Props) => {
  const {
    educationLevels,
    languages,
    audioDescriptionAndSignLanguage,
    teacherResources,
    subjectTreeExtended,
    knowledgeAreaExtended,
  } = filters
  return (
    <>
      {!hiddenFilters?.includes(FilterType.EDUCATION_LEVEL) && (
        <EducationLevel
          educationLevels={educationLevels}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(FilterType.SCHOOL_SUBJECT) && (
        <SchoolSubjectExtended
          subjectTreeExtended={subjectTreeExtended}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(FilterType.KNOWLEDGE_AREA) && (
        <KnowledgeAreaExtended
          subjectTreeExtended={knowledgeAreaExtended}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(FilterType.LANGUAGE) && (
        <Language
          languages={languages}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(FilterType.TEACHER_RESOURCE) && (
        <TeacherResources
          teacherResources={teacherResources}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(
        FilterType.SIGN_LANGUAGE_AND_AUDIO_DESCRIPTION,
      ) && (
        <SignLanguageAndAudioDescription
          signLangAudioDesc={audioDescriptionAndSignLanguage || []}
          searchParams={searchParams}
          updateSearch={executeSearch}
        />
      )}
      {!hiddenFilters?.includes(FilterType.SORT) && (
        <Sort
          searchParams={searchParams}
          updateSearch={executeSearch}
          includeRelevance={Boolean(includeRelevance)}
        />
      )}
    </>
  )
}

export default FilterItems
